import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {
  FETCH,
  DONE,
  FAIL,
  FORM,
  GET, CTP, PERIOD, EXTRA, FILTER, GROUPS, RESET, COMMON,
  SET,
} from "../constants";

import reducerStatuses from "../status";
import {IFormType} from "./types";


const initialState = {
  form: {} as {
    [key in string]: {
      [key in string]: {
        [key in string]: any;
      };
    };
  },
  ctp: {...reducerStatuses, data: null as any},
  ctpFilter: {...reducerStatuses, data: null as any},
  period: {...reducerStatuses, data: [] as any[]},
  setForm: {...reducerStatuses, data: [] as any[]},
};

export default createReducer(initialState, builder =>
  builder
    .addCase(RESET + COMMON, (state, {payload}: PayloadAction<IFormType>) => ({
      ...initialState
    }))


    .addCase(GET + FORM + FETCH, (state, {payload}: PayloadAction<IFormType>) => {
      let keys = [payload.section_type, payload.section_inner_type, payload.form_type]
      keys.reduce((acc, key, index) => {
        if (index === keys.length - 1) {
          if (!acc[key]) {
            acc[key] = { loading: true, success: false, failed: false, data: [] as any[]};
          }
        } else {
          if (!acc[key]) {
            acc[key] = {};
          }
        }
        return acc[key];
      }, state.form);
    })
    .addCase(GET + FORM + FETCH + DONE, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: {
        ...state.form,
        [payload.section_type]: {
          ...state.form[payload.section_type],
          [payload.section_inner_type]: {
            ...state.form[payload.section_type][payload.section_inner_type],
            [payload.form_type]: {
              ...state.form[payload.section_type][payload.section_inner_type][payload.form_type],
              loading: false,
              success: true,
              data: payload.data,
            }
          },
        }
      }
    }))
    .addCase(GET + FORM + FETCH + FAIL, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: initialState.form
    }))
    .addCase(GET + FORM + FETCH + RESET, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: initialState.form
    }))


    .addCase(GET + CTP + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctp: {
        ...state.ctp,
        loading: true,
      },
    }))
    .addCase(GET + CTP + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctp: {
        ...initialState.ctp,
        loading: false,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + CTP + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctp: {
        ...initialState.ctp,
        failed: true,
      },
    }))

    .addCase(GET + CTP + FILTER + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctpFilter: {
        ...state.ctpFilter,
        loading: true,
      },
    }))
    .addCase(GET + CTP + FILTER + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctpFilter: {
        ...initialState.ctpFilter,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + CTP + FILTER + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      ctpFilter: {
        ...initialState.ctpFilter,
        failed: true,
      },
    }))


    .addCase(GET + PERIOD + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      period: {
        ...state.period,
        loading: true,
      },
    }))
    .addCase(GET + PERIOD + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      period: {
        ...initialState.period,
        loading: false,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + PERIOD + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      period: {
        ...initialState.period,
        failed: true,
      },
    }))


    .addCase(GET + FORM + EXTRA + FETCH, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: {
        ...state.form,
        [payload.section_type]: {
          ...state.form[payload.section_type],
          [payload.section_inner_type]: {
            ...state.form[payload.section_type][payload.section_inner_type],
            [payload.form_type]: {
              ...state.form[payload.section_type][payload.section_inner_type][payload.form_type],
              loading: true,
            }
          },
        }
      }
    }))
    .addCase(GET + FORM + EXTRA + FETCH + DONE, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: {
        ...state.form,
        [payload.section_type]: {
          ...state.form[payload.section_type],
          [payload.section_inner_type]: {
            ...state.form[payload.section_type][payload.section_inner_type],
            [payload.form_type]: {
              ...state.form[payload.section_type][payload.section_inner_type][payload.form_type],
              loading: false,
              success: true,
              data: payload.data,
            }
          },
        }
      }
    }))
    .addCase(GET + FORM + EXTRA + FETCH + FAIL, (state, {payload}: PayloadAction<IFormType>) => ({
      ...state,
      form: {
        ...state.form,
        [payload.section_type]: {
          ...state.form[payload.section_type],
          [payload.section_inner_type]: {
            ...state.form[payload.section_type][payload.section_inner_type],
            [payload.form_type]: {
              ...state.form[payload.section_type][payload.section_inner_type][payload.form_type],
              failed: true,
            }
          },
        }
      }
    }))

    .addCase(SET + FORM + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      setForm: {
        ...state.setForm,
        loading: true,
      },
    }))
    .addCase(SET + FORM + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      setForm: {
        ...initialState.setForm,
        loading: false,
        success: true,
      },
    }))
    .addCase(SET + FORM + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      setForm: {
        ...initialState.setForm,
        failed: true,
      },
    }))
    .addCase(SET + FORM + FETCH + RESET, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      setForm: {
        ...initialState.setForm,
      },
    }))
)


